import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { UserProfile } from '@shared/types/user';
import { Order, OrderContainer, Project } from '@shared/types/order';
import { SettingsService } from './settings.service';

@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(
    protected readonly http: HttpClient,
    protected readonly settingsService: SettingsService,
  ) {}

  public getOrder(onlyProjects = false): Observable<OrderContainer> {
    return this.http
      .get<OrderContainer>(`${this.settingsService.v2}client/configurator/get-order`, {
        params: { onlyProjects },
      })
      .pipe(catchError((err) => of(null)));
  }

  public getAnonymousOrder(saveOrder: boolean): Observable<unknown> {
    return this.http
      .get<unknown>(
        `${this.settingsService.v2}client/configurator/get-anonymous-order?${saveOrder}`,
      )
      .pipe(catchError((err) => of(null)));
  }

  public saveOrder(confirmSave = false): Observable<unknown> {
    return this.http
      .post<unknown>(`${this.settingsService.v2}client/configurator/save-order`, null, {
        params: { confirmSave },
      })
      .pipe(catchError((err) => of(null)));
  }

  public setActiveProject(projectId: number, hash?: string): Observable<Project> {
    return this.http
      .post<Project>(`${this.settingsService.v2}client/configurator/set-active-project`, {
        projectId: projectId,
      })
      .pipe(catchError((err) => of(null)));
  }

  public getProfile(): Observable<UserProfile> {
    return this.http
      .get<UserProfile>(`${this.settingsService.v2}client/configurator/get-profile`)
      .pipe(catchError((err) => of(null)));
  }

  public updateProfile(formData: FormData): Observable<UserProfile> {
    return this.http
      .post<UserProfile>(`${this.settingsService.v2}client/configurator/update-profile`, formData)
      .pipe(catchError((err) => of(null)));
  }

  public deleteAvatar(): Observable<UserProfile> {
    return this.http.get<UserProfile>(
      `${this.settingsService.v2}client/configurator/update-profile-delete-avatar`,
    );
  }
}
